import { definition, styles } from "@uesio/ui"
import Icon from "../icon/icon"
import File, { type FileUtilityProps } from "../file/file"

export interface FileVideoProps extends FileUtilityProps {
  muted?: boolean
  autoplay?: boolean
}

const StyleDefaults = Object.freeze({
  preview: [],
  video: [],
  nofile: [],
  nofileicon: [],
})

const FileVideo: definition.UtilityComponent<FileVideoProps> = (props) => {
  const { context, autoplay, muted, fileInfo } = props

  const fileUrl = fileInfo?.url
  // uesio/io.filefield is used by File component directly even though File component is used by more than "filefield". For now, expanding on this to expose
  // support for FileImage, however the css via variants for File & File* components should be discrete and/or exposed another way.
  // TODO: Refactor variants to avoid using uesio/io.filefield for all File related components
  const classes = styles.useUtilityStyleTokens(
    StyleDefaults,
    props,
    "uesio/io.filefield",
  )

  return (
    <File {...props}>
      <div className={classes.preview}>
        {fileUrl ? (
          <video
            className={classes.video}
            autoPlay={autoplay || true}
            muted={muted || true}
          >
            <source src={fileUrl} />
            Your browser does not support the video tag.
          </video>
        ) : (
          <div className={classes.nofile}>
            <Icon
              className={classes.nofileicon}
              context={context}
              icon="movie"
            />
          </div>
        )}
      </div>
    </File>
  )
}

export default FileVideo
